import Tag from '../reusable/Tag';

interface DistrictDataIngestionStatusProps {
  status: string | null;
  size?: 'small' | 'medium';
  className?: string;
}

const DistrictDataIngestionStatus = ({ status, size = 'small', className }: DistrictDataIngestionStatusProps) => {
  const getStatusDisplay = (): { text: string; type: 'pending' | 'completed' | 'progress' | 'error' } => {
    switch (status) {
      case 'NOT_STARTED':
        return { text: 'Not started', type: 'pending' };
      case 'IN_PROGRESS':
        return { text: 'In progress', type: 'progress' };
      case 'UPLOAD_COMPLETE':
        return { text: 'Upload complete', type: 'progress' };
      case 'DISTRICT_DATA_UPLOAD_DONE':
        return { text: 'District data upload done', type: 'progress' };
      case 'EXTRACTION_COMPLETE':
        return { text: 'Extraction complete', type: 'progress' };
      case 'INTERNAL_DATA_QC_COMPLETE':
        return { text: 'Internal data QC complete', type: 'progress' };
      case 'DISTRICT_DATA_QC_COMPLETE':
        return { text: 'District data QC complete', type: 'completed' };
      default:
        return { text: status || 'Not started', type: 'pending' };
    }
  };

  const { text, type } = getStatusDisplay();

  return <Tag type={type} text={text} size={size} className={className} />;
};

export default DistrictDataIngestionStatus;
